export const CLASSIC_MIGRATION = 'requiresIdentityMigration';
export const MIGRATION_PAGE = '/migrate-identity';
export const DASHBOARD_PAGE = '/';
